import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, Typography, Space, Button } from 'antd';
import { FileSearchOutlined, CreditCardOutlined, ArrowUpOutlined, ArrowDownOutlined, } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useApi } from 'sysone-api-mapper';
import { openNotificationWithIcon, TYPE } from "@sysone/insureblocks";
const { Title, Paragraph } = Typography;
const DashboardPage = () => {
    const [activePoliciesNumber, setActivePoliciesNumber] = useState("-");
    const [pendingClaimsNumber, setPendingClaimsNumber] = useState("-");
    const [processedPaymentsNumber, setProcessedPaymentsNumber] = useState("-");
    const [loadingPolicyNumber, setLoadingPolicyNumber] = useState(false);
    const [loadingClaimsNumber, setLoadingClaimsNumber] = useState(false);
    const [loadingPaymentsNumber, setLoadingPaymentsNumber] = useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const api = useApi();
    useEffect(() => {
        getCountries();
        getPartyPolicies();
        getPartyClaims();
        fetchPayments();
    }, []);
    const fetchPayments = async () => {
        try {
            setLoadingPaymentsNumber(true);
            const partyDetailed = await getPartyDetails();
            if (!partyDetailed) {
                throw new Error("Missing party Data");
            }
            const partyCode = partyDetailed?.partyCode;
            const params = {
                paymentStatus: "PAID",
                partyCode: partyCode,
                page: 1,
                pageSize: 1,
            };
            const res = await api.billing.getBillings(params);
            setProcessedPaymentsNumber(res?.total);
            console.log("res", res);
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, "Error looking for billings");
        }
        finally {
            setLoadingPaymentsNumber(false);
        }
    };
    const getCountries = async () => {
        const countries = await api.location.getCountries();
        console.log("countries desde apimapper", countries);
    };
    const getPartyPolicies = async () => {
        try {
            setLoadingPolicyNumber(true);
            const partyDetailed = await getPartyDetails();
            if (!partyDetailed) {
                throw new Error("Missing party Data");
            }
            const res = await api.policy.getPolicies({
                identificationTypeCode: partyDetailed.idType,
                identificationNumber: partyDetailed.idValue,
                processCode: "ACTIVE",
                pageSize: 1,
                page: 1,
            });
            if (res) {
                const policies = res?.values;
                const activeCount = res?.total;
                setActivePoliciesNumber(activeCount);
            }
            else {
                setActivePoliciesNumber("0");
            }
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, error.response?.data?.message || error.message || "error looking for party policies");
        }
        finally {
            setLoadingPolicyNumber(false);
        }
    };
    const getPartyDetails = async () => {
        try {
            const partyInfo = localStorage.getItem("party-info");
            const personType = localStorage.getItem("party-person-type");
            // agrego esto por si no tiene party-info en el token
            if (!partyInfo) {
                console.log("No partyInfo in localStorage, searching manually");
                const partyCode = localStorage.getItem("user-party-code");
                if (!partyCode) {
                    throw new Error("No partyCode in localStorage");
                }
                const res = personType == "INDIVIDUAL" ?
                    await api.party.getIndividualDetails(partyCode) :
                    await api.party.getOrganisationDetails(partyCode);
                const partyObj = {
                    partyCode: partyCode,
                    idType: res.identifications?.values?.find((i) => i.default)?.type?.code,
                    idValue: res.identifications?.values?.find((i) => i.default)?.value,
                };
                localStorage.setItem("party-info", JSON.stringify(partyObj));
                return partyObj;
            }
            const partyJson = JSON.parse(partyInfo);
            return partyJson;
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, error?.message ?? "error looking for party data");
        }
    };
    const getPartyClaims = async () => {
        try {
            setLoadingClaimsNumber(true);
            const partyCode = localStorage.getItem("user-party-code");
            const res = await api.claims.getClaims({
                holderPartyCode: partyCode,
            });
            if (res) {
                const pendingCount = res?.claims?.filter((c) => c?.status?.code !== "COMPLETED")?.length;
                setPendingClaimsNumber(pendingCount);
            }
        }
        catch (error) {
            openNotificationWithIcon(TYPE.ERROR, error?.message ?? "error looking for party claims");
        }
        finally {
            setLoadingClaimsNumber(false);
        }
    };
    const quickActions = [
        {
            title: 'Consulta de Póliza',
            description: 'Busca y consulta información de pólizas',
            icon: _jsx(FileSearchOutlined, { style: { fontSize: 24, color: theme.secondaryColor, backgroundColor: "transparent" } }),
            path: '/consulta-poliza',
        },
        // {
        //   title: 'Denuncia de Siniestros',
        //   description: 'Reporta y gestiona siniestros',
        //   icon: <ExclamationCircleOutlined style={{ fontSize: 24, color: theme.secondaryColor, backgroundColor: "transparent" }} />,
        //   path: '/denuncia-siniestros',
        // },
        // {
        //   title: 'Cotizadores',
        //   description: 'Genera cotizaciones para seguros',
        //   icon: <CalculatorOutlined style={{ fontSize: 24, color: theme.secondaryColor, backgroundColor: "transparent" }} />,
        //   path: '/cotizadores',
        // },
        {
            title: 'Pagos',
            description: 'Gestiona pagos y facturación',
            icon: _jsx(CreditCardOutlined, { style: { fontSize: 24, color: theme.secondaryColor, backgroundColor: "transparent" } }),
            path: '/pagos',
        },
    ];
    const statistics = [
        {
            title: 'Pólizas Activas',
            value: activePoliciesNumber,
            loading: loadingPolicyNumber,
            precision: 0,
            valueStyle: { color: '#3f8600' },
            prefix: _jsx(ArrowUpOutlined, {}),
            suffix: '',
        },
        {
            title: 'Siniestros Pendientes',
            value: pendingClaimsNumber,
            loading: loadingClaimsNumber,
            precision: 0,
            valueStyle: { color: '#cf1322' },
            prefix: _jsx(ArrowDownOutlined, {}),
            suffix: '',
        },
        {
            title: 'Pagos Procesados',
            value: processedPaymentsNumber,
            loading: loadingPaymentsNumber,
            precision: 0,
            valueStyle: { color: '#722ed1' },
            prefix: _jsx(ArrowUpOutlined, {}),
            suffix: '',
        },
    ];
    return (_jsx("div", { className: "responsive-container", children: _jsxs(Space, { direction: "vertical", size: 16, style: { width: '100%' }, children: [_jsxs("div", { style: { textAlign: 'center' }, children: [_jsx(Title, { level: 2, style: {
                                marginBottom: '8px',
                                fontSize: 'clamp(20px, 4vw, 32px)',
                            }, children: "Dashboard" }), _jsx(Paragraph, { style: {
                                marginBottom: '16px',
                                fontSize: 'clamp(14px, 2.5vw, 16px)',
                                maxWidth: '600px',
                                margin: '0 auto 16px auto',
                            }, children: "Bienvenido a la plataforma de gesti\u00F3n de seguros. Aqu\u00ED puedes acceder a todas las funcionalidades principales." })] }), _jsx(Row, { gutter: [16, 16], children: statistics.map((stat, index) => (_jsx(Col, { xs: 24, sm: 12, md: 8, children: _jsx(Card, { hoverable: true, style: {
                                height: '100%',
                                borderRadius: '12px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            }, styles: {
                                body: {
                                    padding: '20px',
                                    textAlign: 'center',
                                }
                            }, children: _jsx(Statistic, { title: stat.title, value: stat.value, loading: stat.loading, precision: stat.precision, valueStyle: {
                                    ...stat.valueStyle,
                                    fontSize: 'clamp(18px, 3vw, 24px)',
                                    fontWeight: 'bold',
                                }, prefix: stat.prefix, suffix: stat.suffix }) }) }, index))) }), _jsxs("div", { children: [_jsx(Title, { level: 3, style: {
                                textAlign: 'center',
                                marginBottom: '24px',
                                fontSize: 'clamp(18px, 3vw, 24px)',
                            }, children: "Acciones R\u00E1pidas" }), _jsx(Row, { gutter: [16, 16], children: quickActions.map((action, index) => (_jsx(Col, { xs: 24, sm: 12, lg: 12, children: _jsxs(Card, { hoverable: true, style: {
                                        height: '100%',
                                        borderRadius: '12px',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    }, styles: {
                                        body: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: '100%',
                                            justifyContent: 'space-between',
                                            padding: '24px',
                                            minHeight: '200px',
                                        }
                                    }, className: "dashboard-action-card", children: [_jsx("div", { children: _jsxs(Space, { direction: "vertical", size: "middle", style: { width: '100%' }, children: [_jsx("div", { style: { textAlign: 'center' }, children: _jsx("div", { style: {
                                                                background: 'transparent',
                                                                borderRadius: '50%',
                                                                width: '64px',
                                                                height: '64px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                margin: '0 auto',
                                                            }, children: React.cloneElement(action.icon, {
                                                                style: {
                                                                    fontSize: 28,
                                                                    color: action.icon.props.style.color,
                                                                }
                                                            }) }) }), _jsxs("div", { style: { textAlign: 'center' }, children: [_jsx(Title, { level: 4, style: {
                                                                    margin: 0,
                                                                    fontSize: 'clamp(16px, 2.5vw, 18px)',
                                                                    lineHeight: 1.3,
                                                                    color: theme.secondaryColor
                                                                }, children: action.title }), _jsx(Paragraph, { type: "secondary", style: {
                                                                    margin: '8px 0 0 0',
                                                                    fontSize: 'clamp(12px, 2vw, 14px)',
                                                                    lineHeight: 1.4,
                                                                }, children: action.description })] })] }) }), _jsx(Button, { type: "primary", block: true, size: "large", style: {
                                                marginTop: 20,
                                                borderRadius: '8px',
                                                fontWeight: 500,
                                                height: '44px',
                                            }, className: "touch-target", onClick: () => navigate(action.path), children: "Acceder" })] }) }, index))) })] })] }) }));
};
export default DashboardPage;
